var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFusdt(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "120px",
    height: "120px",
    viewBox: "0 0 120 120",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\uA730USDt") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-37.4999631%",
    y1: "50.0001949%",
    x2: "112.499935%",
    y2: "50.0001949%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F61FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F61FF",
    offset: "18.4658%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F329F",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-37.4999631%",
    y1: "50.0001949%",
    x2: "112.499935%",
    y2: "50.0001949%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F61FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F61FF",
    offset: "18.4658%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F329F",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "path-3",
    points: "60.0005631 13.507835 100.265658 36.7548123 100.265658 83.2487316 60.0005631 106.495567 19.7355392 83.2487316 19.7355392 36.7548123"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uA730USDt",
    stroke: "none",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M109.385692,31.4871635 L59.9998872,2.97433393 L10.6143084,31.487167 L10.6143084,88.5129442 L59.9998872,117.025669 L109.385692,88.5129476 L109.385692,31.4871635 Z M59.9983389,8.92022235 L104.231645,34.4600072 L104.231645,85.5360352 L59.9983389,111.07582 L15.7650324,85.5360352 L15.7650324,34.4600072 L59.9983389,8.92022235 Z",
    id: "Path",
    fill: "url(#linearGradient-1)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.961531,27.1132505 L64.9998858,2.88674493 C61.9058739,1.10042088 58.0938966,1.10042456 54.9998881,2.88675458 L13.0384522,27.1132473 C9.94444553,28.8995763 8.03845943,32.2008442 8.03845943,35.7734972 L8.03845943,84.2266046 C8.03845943,87.7992634 9.94445167,91.1005357 13.0384663,92.8868626 L54.9999028,117.113265 C58.0939038,118.899584 61.9058668,118.899588 64.9998714,117.113275 L106.961516,92.8868662 C110.055541,91.100542 111.961541,87.7992641 111.961541,84.2265981 L111.961541,35.77351 C111.961541,32.2008502 110.055547,28.899577 106.961531,27.1132505 Z M64.9998917,8.83541218 L101.809832,30.0875833 C104.903849,31.8739097 106.809843,35.1751831 106.809843,38.7478433 L106.809843,81.2522541 C106.809843,84.8249201 104.903843,88.1261981 101.809818,89.9125223 L64.9998774,111.164613 C61.9058728,112.950925 58.0939098,112.950922 54.9999088,111.164603 L18.1901643,89.9125257 C15.0961496,88.1261988 13.1901574,84.8249264 13.1901574,81.2522677 L13.1901574,38.7478297 C13.1901574,35.1751768 15.0961434,31.873909 18.19015,30.0875799 L54.9998946,8.83542233 C58.0939028,7.04909235 61.9058798,7.04908848 64.9998917,8.83541218 Z",
    id: "Path",
    fill: "url(#linearGradient-2)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0005986,108.942672 C87.0300566,108.942672 108.941641,87.0310884 108.941641,60.0016303 C108.941641,32.9723493 87.0300566,11.0607297 60.0005986,11.0607297 C32.9711759,11.0607297 11.0595564,32.9723493 11.0595564,60.0016303 C11.0595564,87.0310884 32.9711759,108.942672 60.0005986,108.942672 Z",
    id: "Path",
    fill: "#F2F2F2",
    fillRule: "nonzero",
    mask: "url(#mask-4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.4287735,38.0017011 L83.4287735,46.5100171 L65.840219,46.5100171 L65.840219,52.409132 C78.193178,53.0395287 87.4612729,55.6287205 87.5300433,58.7321375 L87.5300433,65.2017173 C87.4608842,68.3051344 78.193178,70.8942289 65.840219,71.5246256 L65.840219,86.0017011 L54.1610754,86.0017011 L54.1610754,71.5246256 C41.8080191,70.8942289 32.5399244,68.3051344 32.4711539,65.2017173 L32.4711539,58.7321375 C32.540313,55.6287205 41.8080191,53.0395287 54.1610754,52.409132 L54.1610754,46.5100171 L36.5724237,46.5100171 L36.5724237,38.0017011 L83.4287735,38.0017011 Z M60.0006472,67.0799887 C73.1835152,67.0799887 84.202248,64.8905987 86.8987724,61.9668786 C84.6120544,59.487545 76.3408411,57.5363263 65.840219,57.0004404 L65.840219,63.1767744 C63.9580621,63.2728394 62.0043181,63.323446 60.0006472,63.323446 C57.9968791,63.323446 56.043135,63.2728394 54.1610754,63.1767744 L54.1610754,57.0004404 C43.6603559,57.5363263 35.3891428,59.487545 33.1024248,61.9668786 C35.7990464,64.8905987 46.8176819,67.0799887 60.0006472,67.0799887 Z",
    id: "Shape",
    fill: "#505050",
    fillRule: "evenodd",
    mask: "url(#mask-4)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFusdt);
export default __webpack_public_path__ + "static/media/fusdt.d80608f962f87267ee578961ffae677d.svg";
export { ForwardRef as ReactComponent };